import React from 'react';
import Tag from 'components/common/Tag';

class MsaList extends React.PureComponent {
  render() {
    const { organization } = this.props;
    if (organization.msaMode === 'msa') {
      return (
        <div>
          {organization.allowedMSAs.map(msa => (
            <Tag>{msa.msaName}</Tag>
          ))}
          {organization.numberOfMSAs > 500 ? <div>and {organization.numberOfMSAs - 500} more</div> : null}
        </div>
      );
    }
    if (organization.msaMode === 'state') {
      return (
        <div>
          {organization.allowedStates.map(stateName => (
            <Tag>{stateName}</Tag>
          ))}
        </div>
      );
    }

    return <div />;
  }
}

export default MsaList;



// WEBPACK FOOTER //
// ./src/routes/admin-organization-detail/MsaList/index.js